import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getOwnTerminals() {
  const data = await apiGet('helper/ownTerminals');
  useHelperStore().setOwnTerminals(data);
}
